import React from "react";
import cn from 'classnames';
import styles from './Navigation.module.scss';
function Opacity(props){
    window.addEventListener('click', function (e) {
        if (e && e.target && document.getElementById('outside')?.contains(e.target)) {
           props.closeNav(false)
        } 
      });
     
    return(
        <div id="outside" className={`navigations ${cn(styles.content_box,styles.opcitycontainer, styles.content_box_layout)}`}></div>
    )
}
export default Opacity